// Default values for active web toggles
// Trigger publish #1

const webToggles = {
  ['ab-test-add-to-cart-btn-shows-in-cart']: false,
  ['ab-test-filter-page']: false,
  ['ab-test-showonly-instock-by-default']: false,
  ['ab-test-include-suggested-categories-parent']: false,
  ['abtest-startpage-bannerclicks']: false,
  ['black-friday-signup']: false,
  ['brands-accordions']: false,
  ['breakpoint-indicator']: false,
  ['dev-admin-ui']: false,
  ['disable-3rd-party-scripts']: false,
  ['disable-simplyfy-script']: false,
  ['disable-add-to-cart-for-insurance']: false,
  ['disable-orderconfirmation-timed-out']: false,
  ['disable-write-reviews']: false,
  ['disable-user-reviews']: true,
  ['enable-account-sticky-ab-test']: false,
  ['enable-e4-alternatives-pdp']: false,
  ['enable-bid-availability']: false,
  ['enable-esales-personalization']: true,
  ['enable-favorite-recommendations']: false,
  ['enable-filter-pos-left']: false,
  ['enable-b2b-guest-checkout']: false,
  ['enable-product-variants-android']: false,
  ['enable-product-variants-computers']: false,
  ['enable-product-variants-ipads']: false,
  ['enable-product-variants-iphones']: false,
  ['enable-recently-viewed-sticky']: false,
  ['enable-shop-by-brand-link']: false,
  ['enable-standalone-punchout-cxml']: false,
  ['enable-standalone-punchout-oci']: false,
  ['hide-reviews']: false,
  ['infinity-scroll-with-teaser-cards']: false,
  ['productsite-extended-logs']: false,
  ['show-campaigns-navigation']: false,
  ['show-cart-recommendations']: false,
  ['show-compliant-cookie-banner']: false,
  ['show-encourage-user-info-update']: false,
  ['show-default-error-boundary-fallback']: false,
  ['show-ex-vat-text-for-0-vat']: false,
  ['show-myaccount-dashboard']: false,
  ['show-myaccount-frame-banner']: false,
  ['show-myaccount-info-banner']: false,
  ['show-myaccount-opt-in-banner']: false,
  ['show-myaccount-skyportal-banner']: false,
  ['show-new-account-page-addresses']: false,
  ['show-new-account-page-adminsettings']: false,
  ['show-new-account-page-attest']: false,
  ['show-new-account-page-contacts']: false,
  ['show-new-account-page-orderhistory']: false,
  ['show-new-account-page-rma']: false,
  ['show-new-account-page-services']: false,
  ['show-new-account-page-settings']: false,
  ['show-usp-mobile-banner']: false,
  ['show-price-after-variants']: false,
  ['sorted-facet-values']: false,
  ['use-auth-api-okta']: false,
  ['use-extended-cookie-banner']: false,
  ['use-nl-data-for-belgium']: false,
  ['use-product-api-elevate']: false,
  ['use-proxy']: false,
  ['use-related-products-order-details']: false,
  ['use-request-logging-extra']: false,
  ['use-request-logging-toggles']: false,
  ['use-request-logging']: false,
  ['checkout-microsite']: false,
  ['enable-myaccount-product-recommendations']: false,
  ['mouseflowTestToggle']: false,
  ['enable-information-banner']: false,
  ['header-navigation-solutions-menu-variant']: false,
  ['seo-testing-slider']: false,
  ['categories-by-relevance-on-startpage']: false,
  ['startpage-refactor-test']: false,
  ['ab-test-enable-nav-menu-guides']: false,
  ['ab-test-initial-search-view']: false,
  ['new-relic-log-test']: false,
  ['show-cart-recommendations-iteration-2']: false,
  ['enable-collect-add-to-cart-GA4']: false,
  ['availability-styling-updates']: false,
  ['bot-disable-site-popups']: false,
  ['togglelito-split']: false,
  ['show-hardware-attached-sales-pdp']: false,
  ['enable-prefetching-pdp']: false,
  ['delayed-gtm-script']: false,
  ['use-pricing-api']: false,
  ['push-ga-login-successful-event']: false,
  ['ab_test_buy_ga-test-cookie']: false,
  ['enable-email-verification']: false,
  ['enable-e4-autocomplete']: false, // depricated, can be removed after the deploy enable-initiate-search-bar, enable-e4-search-bar
  ['enable-initiate-search-bar']: false,
  ['enable-e4']: false,
  ['use-cartsite-app']: false,
  ['use-cartsite-favorites-app']: false,
  ['use-cartsite-compare-app']: false,
  ['use-optimizely-dummy-test']: false,
  ['clamped-product-card-title']: false,
  ['enable-new-registration-flow']: false,
  ['service-marketplace-link']: false,
  ['wtf-default-tab-pdp']: false,
  ['wtm-okta-drawer-widget']: false,
  ['enable-skip-eol-product-redirect']: false,
  ['enable-new-user-request-form']: false,
  ['enable-zendesk-auth']: false,
  ['icon-library']: false,
  ['ab-filters-sticky-and-collapsed']: false,
  ['wtm-use-myaccount-overview-app']: false,
  ['enable-b2c-decommission-notification-banner']: false,
  ['use-product-sitemap-from-catalog']: false,
  ['use-catalog-service-pdp']: false,
  ['wt-business-site-selector-popup']: false,
  ['wt-product-availability-v2']: false,
  ['cart-notification-go-to-checkout']: false,
  ['ab-test-shipping-cutoff-banner']: false,
  ['ab-test-minicart-recommendation']: false,
  ['show-plp-campaign-banner']: false,
}

export const webTogglesWithOverrides: WebTogglesWithOverrides = { ...webToggles, ['overrides']: {} }

export type WebToggles = typeof webToggles
export type WebTogglesWithOverrides = WebToggles & {
  overrides: { [key: string]: string | undefined }
}

export const isToggleOverrideEnabled = (
  key: keyof WebTogglesWithOverrides,
  toggles: WebTogglesWithOverrides
) => {
  if (key === 'overrides') {
    throw new Error('Cannot use `overrides` as a toggle key directly')
  }

  if (toggles.overrides && toggles.overrides[key]) {
    return toggles.overrides[key]?.toLocaleLowerCase() === 'true' ? true : false
  }

  return null
}

export const getWebToggles = (toggles: WebTogglesWithOverrides) => {
  return {
    isToggleEnabled: (key: keyof WebTogglesWithOverrides): boolean => {
      const overrideResult = isToggleOverrideEnabled(key, toggles)

      if (overrideResult !== null) {
        return overrideResult
      }

      return toggles[key] as boolean
    },
  }
}

export default webToggles
